<template>
    <div>
        <template v-if="blocks">
            <template v-for="(block, index) in blocks">
                <sav-fold-card
                :key="index"
                :title="cardTitle(block)"
                v-model="block.open"
                class="mb-3"
                v-if="index <= step && !block.hide"
                >
                    <template v-slot:open>
                        <div class="mt-3">
                            <!-- Loader -->
                            <sav-spinner more-class="mb-3" v-show="block.loading" />

                            <!-- Content -->
                            <template v-if="block.type == 'list'">
                                <!-- <component
                                :is="dynamicList"
                                v-if="dynamicList && block.data"
                                :data-src="block.data"
                                :callback="block.callback"
                                :id="block.key"
                                ></component> -->
                                <list-items
                                v-if="block.data"
                                :data-src="block.data"
                                :callback="block.callback"
                                :id="block.key"
                                ></list-items>
                            </template>
                            <template v-if="block.type == 'form'">
                                <sav-form
                                v-if="block.form"
                                :data-src="block.form"
                                :skip="block.skip"
                                :callback="block.callback"
                                :id="block.key"
                                />
                            </template>
                            <template v-if="block.type == 'text'">
                                <div v-html="block.data"></div>
                            </template>
                        </div>
                    </template>
                </sav-fold-card>
            </template>
        </template>
        <slot v-if="blocks && blocks.length > 1" name="validation"></slot>
    </div>
</template>

<script>
import DefaultList from '@/components/SavItemsCardsList.vue'

export default {
    props: {
        blocks: {
            type: Array,
            required: true
        },

        step: {
            type: Number,
            required: true
        }
    },

    components: {
        DefaultList
    },

    data() {
        return {
            dynamicList: null
        }
    },

    methods: {
        cardTitle(block) {
            if (block) {
                // Check if there is closeTitle in block

                if (block.closeTitle) {
                    if (block.title) {
                        return '<small class="text-secondary fw-light d-block mb-2">' + block.title + '</small><div>' + block.closeTitle + '</div>'
                    } else {
                        return block.closeTitle
                    }
                }

                // Check if block has data
                if (block.result && block.result.label) {
                    if (block.title) {
                        return '<small class="text-secondary fw-light d-block mb-2">' + block.title + '</small><div>' + block.result.label + '</div>'
                    } else {
                        return block.result.label
                    }
                }

                // Else return default title
                return block.title
            }
        },
    },
    mounted() {
    }
}
</script>



// WEBPACK FOOTER //
// src/companies/casino/components/default/SavDynamicForm.vue